import {
  IssueCode,
  IssueDto,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemIssueCodeSelector =
  (bomItemId: string, issueCode: IssueCode) =>
  (state: RootAppState): IssueDto => {
    if (!state.project.activeProject) {
      return null
    }

    const bomItem = bomItemSelector(state, bomItemId)

    if (bomItem?.type !== 'Row') {
      return null
    }

    return bomItem.issues.find((x) => x.issueCode === issueCode)
  }
